import { useState } from 'react';
import { Backdrop, Box, Modal, styled } from '@mui/material';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var CustomBackdrop = styled(Backdrop)(function () {
  return {
    backgroundColor: 'transparent!important'
  };
});

var getContainerStyles = function getContainerStyles(width, height) {
  var style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    height: '100%'
  };
  if (width) style.width = width;
  if (height) style.height = height;
  return style;
};

var JoveModal = function JoveModal(props) {
  var children = props.children,
      _props$hideMask = props.hideMask,
      hideMask = _props$hideMask === void 0 ? true : _props$hideMask,
      open = props.open,
      close = props.close,
      containerWidth = props.containerWidth,
      containerHeight = props.containerHeight,
      containerClassName = props.containerClassName;

  var _useState = useState(getContainerStyles(containerWidth, containerHeight)),
      containerStyle = _useState[0],
      setContainerStyle = _useState[1];
  /**
   * methods
   */


  var closeAction = function closeAction() {
    close === null || close === void 0 ? void 0 : close();
  };

  return /*#__PURE__*/_jsx(Modal, {
    open: open,
    disableAutoFocus: true,
    onClose: closeAction,
    slots: {
      backdrop: hideMask ? CustomBackdrop : Backdrop
    },
    children: /*#__PURE__*/_jsx(Box, {
      sx: containerStyle,
      className: clsx('flex flex-col justify-center', containerClassName),
      children: children
    })
  });
};

export default JoveModal;